/**
 * Controller: posDeleteModal
 */
angular.module('acme.view.application.pos.deleteModal.controllers', [])
.controller('PosDeleteModalController', [ '$scope', '$uibModalInstance', 'listItem', 'terminals', 'allow', function($scope, $uibModalInstance, listItem, terminals, allow) {

  $scope.posDeleteModal = {

    name: listItem.name,
    terminals: terminals.data.payload || [],
    allow: allow,

    confirm: function () {
      $uibModalInstance.close(true);
    },

    close: function () {
      $uibModalInstance.dismiss('cancel');
    }

  };

}]);